/* eslint-disable react/no-danger */
import { h, Fragment } from 'preact';
import clsx from 'clsx';
import CloseIcon from '../utils/icons/close.svg';
import Image from '../utils/image';
import { formatMetaobject } from '../utils/storefront/format-resource';

const ExploreMoreFlyout = ({
  benefitsData,
  isOpen,
  setIsOpen,
  currentProduct,
}) => {
  const modalClass = isOpen ? 'modal panel-active' : 'modal modal--closed';

  const handleCloseClick = (e) => {
    e.preventDefault();
    setIsOpen(false);
    document.body.style.overflow = '';
  };

  const madeIn = formatMetaobject(currentProduct.madeIn);

  const benefitsCount = madeIn
    ? benefitsData.benefits_blocks.length + 1
    : benefitsData.benefits_blocks.length;

  let blockWidth;

  if (benefitsCount === 2) {
    blockWidth = 'laptop:w-1/2';
  } else if (benefitsCount === 3) {
    blockWidth = 'laptop:w-1/3';
  } else {
    blockWidth = 'laptop:w-full';
  }

  return (
    <>
      {isOpen && (
        <div
          className="bg-bg-3 opacity-70 w-screen  h-screen z-20 inset-1/2 translate-y-[-50%] translate-x-[-50%] fixed"
          onClick={handleCloseClick}
        />
      )}
      <div
        className={`${modalClass} fixed left-full max-w-width w-full bg-white z-[1000000] translate-x-full transition-transform ease-ease delay-300 flex-col flex
            p-0 laptop:px-10 laptop:py-10
            laptop:translate-x-0 laptop:translate-y-full laptop:rounded-t-sm`}
      >
        <div className="flex justify-between py-5 px-5 laptop:py-0 laptop:px-0">
          <h5 className="heading-5">{benefitsData.title}</h5>
          <button onClick={handleCloseClick} aria-label="Close the flyout">
            <CloseIcon />
          </button>
        </div>
        <div className="w-full h-px bg-grey-400 laptop:bg-black laptop:my-[30px]" />
        <div className="custom-scrollbar flex flex-col justify-between gap-5 p-5 laptop:p-0 laptop:flex-row overflow-y-auto">
          {madeIn && (
            <div
              className={clsx(
                'bg-bg-6 p-5 flex flex-col justify-between',
                blockWidth,
              )}
            >
              <div className="flex items-center justify-center w-9 h-[42px] mb-2">
                <Image
                  src={madeIn.image.url}
                  width={80}
                  height={80}
                  alt={`Benefit image for ${madeIn.heading}`}
                  className="w-[40px]"
                />
              </div>
              <p className="font-m-16 laptop:font-m-18 text-primary-1 mb-2">
                {madeIn.heading}
              </p>
              <p className="font-m-12 text-primary-1 pb-6 mb-4 border-b border-black">
                {madeIn.copy}
              </p>
              {madeIn.cta_url && (
                <a
                  href={madeIn.cta_url}
                  className="btn-primary-stroke-arrow block border-0 w-full bg-bg-6 p-0 before:right-0 after:right-[25px] hover:after:right-0 before:-translate-y-2/4 after:-translate-y-2/4 before:top-[5px] after:top-[5px]"
                >
                  {madeIn.cta_text}
                </a>
              )}
            </div>
          )}
          {benefitsData.benefits_blocks.map((benefit, index) => (
            <div
              className={clsx(
                'bg-bg-6 p-5 flex flex-col justify-between',
                blockWidth,
              )}
              key={index}
            >
              <div className="flex items-center justify-center w-9 h-[42px] mb-2">
                <Image
                  src={benefit.image}
                  width={80}
                  height={80}
                  alt={`Benefit image for ${benefit.text}`}
                  className="w-[40px]"
                />
              </div>
              <p className="font-m-16 laptop:font-m-18 text-primary-1 mb-2">
                {benefit.heading}
              </p>
              <p className="font-m-12 text-primary-1 pb-6 mb-4 border-b border-black">
                {benefit.copy}
              </p>
              {benefit.cta_url && (
                <a
                  href={benefit.cta_url}
                  className="btn-primary-stroke-arrow block border-0 w-full bg-bg-6 p-0 before:right-0 after:right-[25px] hover:after:right-0 before:-translate-y-2/4 after:-translate-y-2/4 before:top-[5px] after:top-[5px]"
                >
                  {benefit.cta_text}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ExploreMoreFlyout;
